import { useEffect, useState } from 'react';
import { useReversalService } from '../../service/reversal';

const useGetReversalFormImage = (id: string) => {
  const {getReversalImage} = useReversalService()
  const [data, setData] = useState<any[]>();
  const [error, setError] = useState<any>()
  const [isLoading, setIsLoading] = useState<Boolean>(false)
  useEffect(() => {
    setIsLoading(true)
  const fetchData = async () => {
    try {
      const response = await getReversalImage(id);
      setData(response.data);
    } catch (err) {
      setError(err);
    }
    finally {
      setIsLoading(false)
    }
  };
  fetchData();
// eslint-disable-next-line react-hooks/exhaustive-deps
}, []);

  return {
    data,
    error,
    isLoading
  };
};

export default useGetReversalFormImage;
